import Typography from "@mui/material/Typography";
import {Box, Button, Stack} from "@mui/material";
import AddCardRoundedIcon from "@mui/icons-material/AddCardRounded";
import {useState, useContext} from "react";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import DinoDialog from "../../../components/Dialog";
import Loading from "../../../components/Loading";
import ConfigContext from "../../../context/ConfigContext";
import useCardInfoQueries from "../../../hooks/queries/useCardInfoQueries";
import useRegisterQueries from "../../../hooks/queries/useRegisterQueries";

const Cards = () => {
    const [deleteCardDialogOpen, setDeleteCardDialogOpen] = useState(false)
    const [current, setCurrent] = useState(1)
    const {ownUrl} = useContext(ConfigContext)

    const {registerCardMutation} = useRegisterQueries()
    const {cardInfoGetForBusinessQuery, cardInfoChangeActiveCardMutation, cardInfoDeleteCardMutation} = useCardInfoQueries()
    const {data: cardInfos, isPending: cardInfosLoading} = cardInfoGetForBusinessQuery


    const changeActiveCard = (c) => cardInfoChangeActiveCardMutation.mutate({card_id: c})
    const deleteCard = (c) => cardInfoDeleteCardMutation.mutate({card_id: c})

    const addCard = () => registerCardMutation.mutate({redirect_url: `${ownUrl}/payment-over`}, {
        onSuccess: response => window.location.href = response.paymentLink
    })

    const cardDeleteActions = <>
        <Button variant='outlined' style={{padding: 15}} onClick={() => setDeleteCardDialogOpen(false)}>Mégsem</Button>
        <Button variant='contained' style={{padding: 15}} onClick={() => {
            setDeleteCardDialogOpen(false)
            deleteCard(current)
        }} endIcon={<DeleteForeverRoundedIcon/>}>Kártya törlése</Button>
    </>

    if (cardInfosLoading || cardInfoChangeActiveCardMutation.isPending || cardInfoDeleteCardMutation.isPending || registerCardMutation.isPending) return <Loading isLoading />

    return <div className="white-card">
        <Typography variant='subtitle2'>Bankkártyák</Typography>
        <Typography variant='body2' color='#536B74' gutterBottom>
            Új kártya hozzáadása esetén időbe
            telhet míg az adatok ellenőrízve lesznek, addig az xxxx-xxxx-xxxx-xxxx számú kártyát mutatja
            a rendszer.
        </Typography>
        <Stack spacing={1} marginBottom={2}>
            {cardInfos?.map((c, i) => <Box key={`card_${i}`}>
                <Stack direction='row' spacing={2}>
                    <Stack spacing={1} className='bank-card'>
                        <Box
                            style={{
                                width: '30px',
                                height: '20px',
                                background: '#c79a00',
                                borderRadius: '5px',
                                border: '1px solid #866b00'
                            }}/>
                        <Typography variant='caption' color='#fff'>
                            {c.card_mask}
                        </Typography>
                        <Typography variant='caption' color='#fff'>
                            VALID: {c.expiry}
                        </Typography>
                    </Stack>
                    <Stack spacing={1}>
                        {c.active ?
                            <Button
                                disabled
                                variant='contained'>
                                Kiválasztva
                            </Button>
                            :
                            <Button
                                onClick={() => changeActiveCard(c.id)}
                                variant='contained'>
                                Kiválasztás
                            </Button>
                        }
                        <Button
                            onClick={() => {
                                setCurrent(c.id)
                                setDeleteCardDialogOpen(true)
                            }}>
                            Törlés
                        </Button>
                    </Stack>
                </Stack>
            </Box>)}
        </Stack>
        <Button
            variant='contained'
            endIcon={<AddCardRoundedIcon/>}
            onClick={addCard}>
            Kártya hozzáadása
        </Button>


        <DinoDialog
            open={deleteCardDialogOpen}
            handleClose={() => setDeleteCardDialogOpen(false)}
            title='Kártya törlése'
            subtitle='Biztosan törlöd ezt a kártyát?'
            actions={cardDeleteActions}>
        </DinoDialog>

    </div>
}

export default Cards